class Utilities {

  constructor() {
    //polyfill startswith for IE (from MDN)
    if (!String.prototype.startsWith) {
      String.prototype.startsWith = function(search, pos) {
        return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
      };
    }
    this.translationMap = {
      '/en': '/fr'
    }
  }

  isFrench(path) {
    return (path.startsWith('/fr'));
  }

  hasInput(item) {
		if (typeof item == 'undefined' || item === '' || item == null) {
			return false;
		}
		if (Array.isArray(item) && item.length === 0) {
			return false;
		}
		return true;
	}

	lang(englishItem, frenchItem, isFrench) {
		if (isFrench && this.hasInput(frenchItem)) {
			return frenchItem;
		} else if (this.hasInput(englishItem)) {
			return englishItem;
		} else if (this.hasInput(frenchItem)) {
			return frenchItem;
		}
		return null;
  }
  
  //get all the pages in the sitemap that use this layout
  getPagesWithLayout(layout, sitemap) {
    let pages = sitemap.filter(x => x.layout === layout);
    return pages;
  }

  getTranslation(path, targetLang) {
    //loop through the translation map
    for(const prop in this.translationMap) {
      if (targetLang === 'en') {
        if (this.translationMap[prop] === path) {
          return prop;
        }
      } else {
        if (prop === path) {
          return this.translationMap[prop];
        }
      }
    }
    //use default
    return (targetLang === 'en') ? '/en' : '/fr';
  }

  setTitle(titleEn, titleFr, lang) {
    const title = Utils.lang(titleEn, titleFr, lang);
    document.title = `${title}`;
  }

  setDefaultTitle() {
    document.title = 'PPI';
  }

  isIE11() {
    var ua = window.navigator.userAgent;
    return (ua.indexOf("Trident/7.0") > -1);
  }

}

export const Utils = new Utilities();